export const EUR_TO_HRK = 7.53450;
